import { RefObject } from "react";
import { useForm } from "react-hook-form";
import { useQueryClient } from "@tanstack/react-query";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotification, useTranslate } from "@refinedev/core";

import { ModalRef } from "@shared/components";
import { useCreateLevelMutation } from "@modules/levels/services/mutations";
import { LevelFormValues, levelSchema } from "@modules/levels/validations";
import { listLevelsQueryKey } from "@modules/levels/services/queries/listLevels/query";

export function useCreateLevelModal(modalRef: RefObject<ModalRef>, onComplete?: () => void) {
  const queryClient = useQueryClient();
  const translate = useTranslate();
  const { open } = useNotification();

  const methods = useForm<LevelFormValues>({
    resolver: zodResolver(levelSchema()),
    mode: "onBlur",
  });

  const { mutateAsync, isPending } = useCreateLevelMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: listLevelsQueryKey,
        refetchType: 'all',
      });

      open?.({
        type: "success",
        message: translate("level_admin.success.create"),
      });

      onComplete?.();
      modalRef.current?.close();
    },
  });


  return {
    methods,
    mutateAsync,
    isPending,
  };
}
